import { VenueDetailsBySlugResponse } from "common/hooks";
import VenuePhotosContent from "@/components/VenueDetailBasic/VenuePhotosContent";

type PhotosTabProps = {
  venueDetailsResponse: VenueDetailsBySlugResponse;
  fullSize?: boolean;
  openAllPhotosInline?: boolean;
  top5Photos?: unknown[];
  cid?: string;
  tid?: string;
  onRefresh: () => void;
  onShowPhotosDetailView?: (initialCategoryId: number | null) => void;
};

function PhotosTab({
  venueDetailsResponse,
  openAllPhotosInline,
  cid,
  tid,
  onRefresh,
  onShowPhotosDetailView,
}: PhotosTabProps) {
  return (
    <VenuePhotosContent
      venueDetailsResponse={venueDetailsResponse}
      sort="category"
      isLoading={false}
      onRefresh={onRefresh}
      onFlag={() => {
        // optional callback if you want to handle flag action in parent
      }}
      mode={openAllPhotosInline ? "nearby" : ""}
      cid={cid}
      tid={tid}
      doNotShowBackButton={true}
      onShowPhotosDetailView={onShowPhotosDetailView}
    />
  );
}

export default PhotosTab;
